import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, MapPin, ArrowRight } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { api, track } from "@/lib/api";
import { Photo, usePriceText } from "@/components/dm/ui";

export const Spotlight = ({ hub }) => {
  const { t, L, cat, areaOf } = useApp();
  const price = usePriceText();
  const [p, setP] = useState(null);
  useEffect(() => { setP(null); api.get("/spotlight", { params: { hub: hub.id } }).then((r) => setP(r.data.post)).catch(() => {}); }, [hub.id]);
  if (!p) return null;
  const area = areaOf?.(p.area_id);
  const pr = price(p);
  return (
    <section data-testid="home-spotlight" className="space-y-3">
      <h2 className="text-base md:text-lg font-extrabold inline-flex items-center gap-2"><Award className="w-5 h-5 text-[#D97706]" aria-hidden="true" />{t("spotlight_title", { city: L(hub) })}</h2>
      <Link to={`/post/${p.id}`} onClick={() => track("spotlight_click", { post_id: p.id, hub_id: p.hub_id, category_id: p.category_id })} data-testid="spotlight-card"
        className="press group grid grid-cols-1 sm:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] rounded-[24px] overflow-hidden bg-[#FFFDF9] ring-2 ring-[#F59E0B] card-shadow">
        <div className="relative aspect-[4/3] sm:aspect-auto sm:min-h-[260px]">
          <Photo src={p.photos?.[0]} alt={p.title} icon={cat(p.category_id)?.icon} className="absolute inset-0 w-full h-full" />
          <span className="absolute top-3 left-3 rounded-full bg-[#F59E0B] text-[#291E18] px-3 py-1 text-xs font-extrabold inline-flex items-center gap-1"><Award className="w-3.5 h-3.5" />{t("spotlight_badge")}</span>
          {p.photos?.length > 1 && (
            <div className="absolute bottom-3 right-3 flex gap-1.5">
              {p.photos.slice(1, 4).map((src) => <Photo key={src} src={src} alt="" className="w-14 h-14 rounded-xl ring-2 ring-white/90 hidden sm:block" />)}
            </div>
          )}
        </div>
        <div className="p-5 flex flex-col gap-2 min-w-0">
          <span className="text-xs font-semibold text-[#C2410C]">{L(cat(p.category_id))}</span>
          <h3 className="text-xl font-extrabold leading-snug line-clamp-2 text-[#291E18]">{p.title}</h3>
          {pr && <div data-testid="spotlight-price" className="text-lg font-extrabold text-[#92400E]">{pr}</div>}
          <p className="text-sm text-[#6B5E55] line-clamp-3">{p.description}</p>
          <div className="text-sm text-[#6B5E55] inline-flex items-center gap-1"><MapPin className="w-4 h-4" aria-hidden="true" />{L(hub)}{area ? ` · ${L(area)}` : ""}{p.poster?.name ? ` · ${p.poster.name}` : ""}</div>
          <span className="mt-auto pt-2 inline-flex items-center gap-1 font-extrabold text-[#1E4D3B]">{t("spotlight_cta")}<ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" /></span>
        </div>
      </Link>
    </section>
  );
};
